/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamBulkPatchItemRequestSchema } from './teamBulkPatchItemRequestSchema';

export const teamBulkPatchRequestSchema = z.object({
  get teams() {
    return z.array(teamBulkPatchItemRequestSchema).min(0).max(100);
  },
});
